// Patch: restore correct selectedOptionValues getter
// (fixes corruption in product-variants.js where CSS selector was split across lines)
customElements.whenDefined('product-variant-selects').then(() => {
  const cls = customElements.get('product-variant-selects');
  if (!cls) return;
  Object.defineProperty(cls.prototype, 'selectedOptionValues', {
    get() {
      return Array.from(
        this.querySelectorAll('select option[selected], fieldset input:checked')
      ).map(({ dataset }) => dataset.optionValueId);
    },
    configurable: true
  });
});

// Patch: fix gallery image not updating on initial page load when ?variant= is in URL.
// Root cause: ProductInfo.initUpdateMedia() calls swiper-product-gallery.setActiveMedia()
// synchronously in connectedCallback, before the Swiper instance is initialized.
// Fix: after DOMContentLoaded (when Swiper is ready), find the pre-selected variant
// and drive the gallery to the correct slide.
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const variantIdFromUrl = parseInt(params.get('variant'), 10);
  if (!variantIdFromUrl) return;

  // Give Swiper a tick to finish its own init (it also hooks DOMContentLoaded)
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;

      // Read the selected variant JSON that Shopify renders server-side
      const selectedVariantEl = productInfo.querySelector(
        'product-variant-selects [data-selected-variant]'
      );
      if (!selectedVariantEl) return;

      let variant;
      try {
        variant = JSON.parse(selectedVariantEl.innerHTML);
      } catch (e) {
        return;
      }
      if (!variant || variant.id !== variantIdFromUrl) return;

      const mediaId = variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;

      // Scroll/activate grid layout if present
      const gridLayout = productInfo.querySelector('.main-product__media--grid');
      if (gridLayout) {
        gridLayout.querySelectorAll('.swiper-slide').forEach(item => item.classList.remove('active'));
        const activeSlide = gridLayout.querySelector(`.swiper-slide[data-media-id="${mediaId}"]`);
        if (activeSlide) activeSlide.classList.add('active');
      }

      // Drive swiper-product-gallery to the right slide
      const gallery = productInfo.querySelector('swiper-product-gallery');
      if (gallery && gallery.instance && typeof gallery.instance.slideTo === 'function') {
        const mediaSlide = Array.from(gallery.querySelectorAll('[data-media-id]'))
          .find(el => Number(el.dataset.mediaId) === mediaId);
        if (mediaSlide) {
          gallery.instance.slideTo(Number(mediaSlide.dataset.index), 0); // 0ms = instant, no animation
        }
      } else if (gallery && typeof gallery.setActiveMedia === 'function') {
        // Fallback: call setActiveMedia (works when instance is ready but hideOtherVariantsMedia check passes)
        gallery.setActiveMedia(mediaId);
      }
    });
  });
});
